module.exports = __webpack_public_path__ + "static/img/community.24f78891.png";